import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

import { createVuetify } from 'vuetify';
//import { aliases, mdi } from 'vuetify/iconsets/mdi';


export default createVuetify({
  theme: {
    defaultTheme: 'CustomTheme',
    themes: {
      CustomTheme: {
        dark: false,
        colors: {
          background: '#FFFFFF',
          surface: '#FFFFFF',
          'surface-variant': '#f5f5f5',
          primary: '#343a40',
          footer: '#f8f9fa',
          secondary: '#6c757d',
          accent: '#82B1FF',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FB8C00',
        },
      },
      DarkTheme: {
        dark: true,
        colors: {
          background: '#1e1e1e',
          surface: '#2c2c2c',
          'surface-variant': '#383838',
          primary: '#4a4a4a',
          footer: '#212529',
          secondary: '#9e9e9e',
          accent: '#82B1FF',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FB8C00',
        },
      },
    },
  },
});
